import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWorkflows = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 19 19"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.965 3.62a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0M4.007 18.665c.181.18.475.18.656 0l2.892-2.893a.464.464 0 0 0 0-.654l-2.892-2.893a.464.464 0 0 0-.656 0l-2.892 2.893a.464.464 0 0 0 0 .654zM14.779 1.2h3.274c.453 0 .819.453.819.82v3.273a.82.82 0 0 1-.82.82H14.78c-.453 0-.819-.453-.819-.82V2.02c0-.452.366-.819.819-.819M4.225 7.656c-.431 0-.825.322-.825.754v1.945c0 .407.418.69.825.69s.825-.283.825-.69V8.41c0-.432-.394-.754-.825-.754M12.607 3.794a.825.825 0 0 0-.825-.825H9.176c-.442 0-.784.382-.784.825s.342.825.784.825h2.606c.456 0 .825-.37.825-.825"
    />
  </svg>
);
export default SvgWorkflows;
